import OtPaymentAuthorizationClient from "./OTPaymentAuthorizationClient";
import {
  formatDateDelmtrMMDDYYYY,
  formatDateDelmtrYYYYMMDD,
} from "../../utils/dateUtil";

import BaseClient from "../base/baseClient";
import store from "../../../reduxStore/store";
import ecommEndpoints from "../../features/endPoints/ecommEndpoints";

const PrepayExistingPaymentMethodV2 = (
  isNew,
  otPaymentType,
  paymentData,
  cusnum = "",
  salesAgreementObj,
  authorizationData = ""
) => {
  const preferredEmail = store.getState().accountSummary.preferredEmail;
  const selectedCustomer = store.getState().login.selectedCustomer;

  const {
    salesAgrLst,
    donationList,
    servicesEnrolled,
    totalPaymentAmount,
    donAmount,
  } = prepareSalesAgrList(salesAgreementObj);

  // Calculate total of payTotalPymt from salesAgrLst, handling comma-formatted numbers
  let payTotalPymtSum = salesAgrLst.reduce(
    (sum, item) =>
      sum +
      (Number(
        item.payTotalPymt && item.payTotalPymt.toString().replace(/,/g, "")
      ) || 0),
    0
  );

  // If donationObj and donAmount exist, add to payTotalPymtSum
  if (
    salesAgreementObj &&
    salesAgreementObj.donationObj &&
    salesAgreementObj.donationObj.donAmount
  ) {
    const donAmount =
      Number(
        salesAgreementObj.donationObj.donAmount.toString().replace(/,/g, "")
      ) || 0;
    payTotalPymtSum += donAmount;
  }
  payTotalPymtSum = Number(payTotalPymtSum).toFixed(2);

  const selectedCustomerInfo = store.getState().login.customerInfo;

  const emailInfo = selectedCustomerInfo[0]
        ? selectedCustomerInfo[0].EmailAddress
        : "";

  // Compare payTotalPymtSum and authorizedCardDetails.PaymentAmount before API call
  const authorizedAmount =
    authorizationData != "" && authorizationData.PaymentAmount != null
      ? Number(
          authorizationData.PaymentAmount.toString().replace(/,/g, "")
        ).toFixed(2)
      : null;
  
  const requestBodyEasyPay = {
    activeServiceAgreements: salesAgrLst,
    customerNum: selectedCustomer ? selectedCustomer : "",
    email: emailInfo ? emailInfo : "",
    paymentMethod: {
      method: otPaymentType,
      cartDetails: {
        payPymtType: paymentData.pccCashType,
        cardType: paymentData.pccCashSubType,
        paymentToken: paymentData.pccTokenNum,
        payCCDExpDte: paymentData.pccExpireDte
          ? formatDateDelmtrYYYYMMDD(paymentData.pccExpireDte.toString(), "-")
          : "",
        payRoutingNum: paymentData.pccRoutingNum,
        accountNumber: paymentData.pccAcctLast4,
        accCcdSid: paymentData.pccSid ? paymentData.pccSid : "",
        accCcdExpDte:
          paymentData.pccExpireDte != "0" ? paymentData.pccExpireDte : "",
        accountHolderName: selectedCustomerInfo[0]
          ? selectedCustomerInfo[0].BusinessName
          : "",
        TransactionID:
          authorizationData != "" ? authorizationData.TransactionID : "",
        AuthorizationCode:
          authorizationData != "" ? authorizationData.AuthorizationCode : "",
        VisaTransID:
          authorizationData != "" ? authorizationData.VisaTransID : "",
        CommercialFlag:
          authorizationData != "" ? authorizationData.CommercialFlag : "",
        CommercialLevel:
          authorizationData != "" ? authorizationData.CommercialLevel : "",
        AuthorizationDate:
          authorizationData != "" ? authorizationData.AuthorizationDate : "",
        otpayment: otPaymentType,
        flag: isNew == true ? "New" : "Exist",
        totalPaymentAmount: payTotalPymtSum,
        authorizedTotal:
          authorizationData != "" ? authorizationData.PaymentAmount : "",
        source: cusnum === "MyInvoice" ? "MyInvoice" : "MyAccount",
      },
    },
    donationList: donationList,
    servicesEnrolled: servicesEnrolled,
  };

  const requestBodyClub =
  {
    "activeServiceAgreements": salesAgrLst,
    "customerNum": selectedCustomer ? selectedCustomer : "",
    "email": emailInfo? emailInfo : "",
    "paymentMethod": {
      "method": otPaymentType,
      "cartDetails": {
        "payPymtType": paymentData.pccCashType,
        "cardType": paymentData.pccCashSubType,
        "paymentToken": paymentData.pccTokenNum,
        "payCCDExpDte": paymentData.pccExpireDte ? formatDateDelmtrYYYYMMDD(paymentData.pccExpireDte.toString(), '-') : '',
        "payRoutingNum": paymentData.pccRoutingNum,
        "accountNumber": paymentData.pccAcctLast4,
        "accCcdSid": paymentData.pccSid?paymentData.pccSid:"",
        "accCcdExpDte": paymentData.pccExpireDte != '0'?paymentData.pccExpireDte:"",
        "accountHolderName": selectedCustomerInfo[0]?selectedCustomerInfo[0].BusinessName : "",
        "otpayment": otPaymentType,
        "flag": isNew == true?"New":"Exist",
        "totalPaymentAmount": payTotalPymtSum,
        "source": cusnum === "MyInvoice" ? "MyInvoice" : "MyAccount",
      }
    },
    "donationList": donationList,
    "servicesEnrolled" : servicesEnrolled,
    "zipcode": paymentData?.BillingAddress ? paymentData?.BillingAddress?.adrPostalCode : "00000"
  }

  const todaysDate = formatDateDelmtrMMDDYYYY(new Date(), "-");
  const customProperties = {
    payment_last_four: paymentData.pccAcctLast4,
    confirmation_number: "",
    services_enrolled: servicesEnrolled.join(),
    enrollment_date: todaysDate,
  };

  const { post: postClient } = BaseClient();
  
  if(otPaymentType === 'easypay' || paymentData.pccPaymentType == 'BankAccount'){
    return postClient(process.env.REACT_APP_ECOMM_URL + ecommEndpoints.prePayPaymentV2(), requestBodyEasyPay, {}, true, mapResponse, mapError);
  } else {
    return postClient(process.env.REACT_APP_ECOMM_URL + ecommEndpoints.authorizationAndOTPayment(), requestBodyClub, {}, true, mapResponse, mapError);
  }
}

//Prepare sales agreement list
const prepareSalesAgrList = (salesAgreements) => {
  let servicesEnrolled = [];
  let totalPaymentAmount = 0;
  let salesAgrLst = salesAgreements.value.map((agrNum) => {
    let agr = salesAgreements.data[agrNum];
    let isInvoiceExists = agr && agr.invoiceNumber ? true : false;
    let svcDesc = isInvoiceExists ? agr.svcDescription : agr.svcLineDesc;
    servicesEnrolled.push(svcDesc);
    let payTotalPymt = isInvoiceExists
      ? agr?.totalAmt ?? agr?.invoice?.invoiceBalance ?? 0
      : agr?.invoice?.invoiceBalance ?? agr?.PrePay?.[0]?.yiaTotalAmt ?? 0;

    let cleanAgrNum = agrNum.split("_")[0];  
    return {
      payTotalPymt: payTotalPymt,
      salesAgrNum: isInvoiceExists ? agr.salesAgrNum : cleanAgrNum,
      invoiceNo: isInvoiceExists ? agr.invoiceNumber : "",
      payBunit: agr.asgBunit || "",
    };
  });

  let donAmount = (salesAgreements?.donationObj || {})?.donAmount || 0;

  let donationList = [
    {
      donCode: (salesAgreements?.donationObj || {})?.donCode || "",
    },
  ];

  return {
    salesAgrLst,
    donAmount,
    donationList,
    servicesEnrolled,
    totalPaymentAmount,
  };
};

const PrepayNewPaymentMethodV2 = (
  isNew,
  otPaymentType,
  paymentData,
  cusnum,
  salesAgreementObj,
  authorizedCardDetails = ""
) => {
  const preferredEmail = store.getState().accountSummary.preferredEmail;
  const selectedCustomer = store.getState().login.selectedCustomer;

  const {
    salesAgrLst,
    donAmount,
    donationList,
    servicesEnrolled,
    totalPaymentAmount,
  } = prepareSalesAgrList(salesAgreementObj);
  let payTotalPymtSum = salesAgrLst.reduce(
    (sum, item) =>
      sum +
      (Number(
        item.payTotalPymt && item.payTotalPymt.toString().replace(/,/g, "")
      ) || 0),
    0
  );

  // If donationObj and donAmount exist, add to payTotalPymtSum
  if (
    salesAgreementObj &&
    salesAgreementObj.donationObj &&
    salesAgreementObj.donationObj.donAmount
  ) {
    const donAmount =
      Number(
        salesAgreementObj.donationObj.donAmount.toString().replace(/,/g, "")
      ) || 0;
    payTotalPymtSum += donAmount;
  }
  payTotalPymtSum = Number(payTotalPymtSum).toFixed(2);

  const selectedCustomerInfo = store.getState().login.customerInfo;
  const emailInfo = selectedCustomerInfo[0]
        ? selectedCustomerInfo[0].EmailAddress
        : "";

  // Compare payTotalPymtSum and authorizedCardDetails.PaymentAmount before API call
  const authorizedAmount =
    authorizedCardDetails != "" && authorizedCardDetails.PaymentAmount != null
      ? Number(
          authorizedCardDetails.PaymentAmount.toString().replace(/,/g, "")
        ).toFixed(2)
      : null;

  let requestBody = {};
  if (paymentData.isCreditCard) {
    requestBody = {
      activeServiceAgreements: salesAgrLst,
      customerNum: selectedCustomer ? selectedCustomer : "",
      email: emailInfo ? emailInfo : "",
      paymentMethod: {
        method: otPaymentType,
        cartDetails: {
          payPymtType: "CCD",
          cardType: paymentData.cashSubType,
          paymentToken: paymentData["Card Number"],
          payCCDExpDte: `${paymentData["Expiration Year"]}-${paymentData["Expiration Month"]}-01`,
          payRoutingNum: "",
          accountNumber: (
            paymentData["Card Number"] || paymentData["Account Number"] || paymentData["Value"]
          ).slice(-4),
          accountHolderName: selectedCustomerInfo[0]
            ? selectedCustomerInfo[0].BusinessName
            : "",
          accCcdExpDte: `${paymentData["Expiration Year"]}${paymentData["Expiration Month"]}01`,
          accCcdSid: 0,
          TransactionID:
            authorizedCardDetails != ""
              ? authorizedCardDetails.TransactionID
              : "",
          AuthorizationCode:
            authorizedCardDetails != ""
              ? authorizedCardDetails.AuthorizationCode
              : "",
          VisaTransID:
            authorizedCardDetails != ""
              ? authorizedCardDetails.VisaTransID
              : "",
          CommercialFlag:
            authorizedCardDetails != ""
              ? authorizedCardDetails.CommercialFlag
              : "",
          CommercialLevel:
            authorizedCardDetails != ""
              ? authorizedCardDetails.CommercialLevel
              : "",
          AuthorizationDate:
            authorizedCardDetails != ""
              ? authorizedCardDetails.AuthorizationDate
              : "",
          otpayment: otPaymentType,
          flag: isNew == true ? "New" : "Exist",
          totalPaymentAmount: payTotalPymtSum,
          authorizedTotal:
            authorizedCardDetails != ""
              ? authorizedCardDetails.PaymentAmount
              : "",
          source: cusnum === "MyInvoice" ? "MyInvoice" : "MyAccount",
        },
      },
      donationList: donationList,
      servicesEnrolled: servicesEnrolled,
    };
  } else if (paymentData.isAccount) {
    let routingNum = paymentData["Routing Number"];
    if (!routingNum || routingNum.length > 9) {
      return Promise.reject({
        genericMessage:
          "Routing Number has too many digits. Maximum of 9 digits. Please try again.",
      });
    }
    if (!routingNum || routingNum.length < 9) {
      return Promise.reject({
        genericMessage:
          "Routing Number has too few digits. Should be 9 digits long. Please try again.",
      });
    }
    requestBody = {
      activeServiceAgreements: salesAgrLst,
      customerNum: selectedCustomer ? selectedCustomer : "",
      email: emailInfo ? emailInfo : "",
      paymentMethod: {
        method: otPaymentType,
        cartDetails: {
          payPymtType: "ACH",
          cardType: "CHK",
          paymentToken: paymentData["Account Number"],
          payCCDExpDte: "",
          payRoutingNum: paymentData["Routing Number"],
          accountNumber: (
            paymentData["Card Number"] || paymentData["Account Number"] || paymentData["Value"]
          ).slice(-4),
          accountHolderName: selectedCustomerInfo[0]
            ? selectedCustomerInfo[0].BusinessName
            : "",
          accCcdExpDte: "",
          accCcdSid: 0,
          otpayment: otPaymentType,
          flag: isNew == true ? "New" : "Exist",
          totalPaymentAmount: payTotalPymtSum,
          authorizedTotal: "",
          source: cusnum === "MyInvoice" ? "MyInvoice" : "MyAccount",
        },
      },
      donationList: donationList,
      servicesEnrolled: servicesEnrolled,
    };
  }

  const todaysDate = formatDateDelmtrMMDDYYYY(new Date(), "-");
  const customProperties = {
    payment_last_four: (
      paymentData["Card Number"] || paymentData["Account Number"] || paymentData["Value"]
    ).slice(-4),
    confirmation_number: "",
    services_enrolled: servicesEnrolled.join(),
    enrollment_date: todaysDate,
  };

  const { post: postClient } = BaseClient();

  return postClient(
    process.env.REACT_APP_ECOMM_URL + ecommEndpoints.prePayPaymentV2(),
    requestBody,
    {},
    true,
    mapResponse,
    mapError
  );
};

//Prepare sales agreement list for guest checkout
const prepareSalesAgrListForGuestCheckout = (salesAgreements) => {
  let servicesEnrolled = [];
  let salesAgrLst = salesAgreements.map((agr) => {
    let isInvoiceExists = agr.invoiceNum ? true : false;
    let svcDesc = isInvoiceExists ? agr.svcDescription : agr.svcServiceLine;
    servicesEnrolled.push(svcDesc);
    return {
      payTotalPymt: isInvoiceExists
        ? agr.invoiceBalance
        : agr.PrePay
        ? agr.PrePay[0].yiaTotalAmt
        : 0,
      salesAgrNum: isInvoiceExists ? agr.salesAgrNum : "",
      invoiceNo: isInvoiceExists ? agr.invoiceNum : "",
      payBunit: "",
    };
  });
  return { salesAgrLst, servicesEnrolled };
};

const GuestCheckoutNewPaymentMethod = (
  isNew,
  otPaymentType,
  paymentData,
  cusnum,
  salesAgreementObj,
  authorizedCardDetails = "",
  customerInfo
) => {
  const { salesAgrLst, servicesEnrolled } =
    prepareSalesAgrListForGuestCheckout(salesAgreementObj);
  let payTotalPymtSum = salesAgrLst.reduce(
    (sum, item) =>
      sum +
      (Number(
        item.payTotalPymt && item.payTotalPymt.toString().replace(/,/g, "")
      ) || 0),
    0
  );

  // If donationObj and donAmount exist, add to payTotalPymtSum
  if (
    salesAgreementObj &&
    salesAgreementObj.donationObj &&
    salesAgreementObj.donationObj.donAmount
  ) {
    const donAmount =
      Number(
        salesAgreementObj.donationObj.donAmount.toString().replace(/,/g, "")
      ) || 0;
    payTotalPymtSum += donAmount;
  }
  payTotalPymtSum = Number(payTotalPymtSum).toFixed(2);

  // Compare payTotalPymtSum and authorizedCardDetails.PaymentAmount before API call
  const authorizedAmount =
    authorizedCardDetails != "" && authorizedCardDetails.PaymentAmount != null
      ? Number(
          authorizedCardDetails.PaymentAmount.toString().replace(/,/g, "")
        ).toFixed(2)
      : null;

  if (authorizedAmount !== null && payTotalPymtSum !== authorizedAmount) {
    const requestBodyAuthorization = {
      customerNumber: cusnum,
      email: customerInfo.EmailAddress ? customerInfo.EmailAddress : "",
      totalAmount: payTotalPymtSum,
      authorizedTotal: authorizedAmount,
      source: "MyAccount",
      transactionId:
        authorizedCardDetails != "" ? authorizedCardDetails.TransactionID : "",
    };
    //authClient.post(endpoint.OTpaymentAuthorization(), requestBodyAuthorization, mapResponse, mapError);
    OtPaymentAuthorizationClient(requestBodyAuthorization)
      .then((response) => {
        return console.log(response);
      })
      .catch((error) => {
        return Promise.reject({
          genericMessage: `An error has occurred in processing the payment. Please contact Customer Care at 1-877-760-0075`,
        });
      });

    return Promise.reject({
      genericMessage: `An error has occurred in processing the payment. Please contact Customer Care at 1-877-760-0075`,
    });
  }

  let requestBody = {};

  if (paymentData.isCreditCard) {
    requestBody = {
      activeServiceAgreements: salesAgrLst,
      customerNum: cusnum,
      email: customerInfo.EmailAddress ? customerInfo.EmailAddress : "",
      paymentMethod: {
        method: otPaymentType,
        cartDetails: {
          payPymtType: "CCD",
          cardType: paymentData.cashSubType,
          paymentToken: paymentData["Card Number"],
          payCCDExpDte: `${paymentData["Expiration Year"]}-${paymentData["Expiration Month"]}-01`,
          payRoutingNum: "",
          accountNumber: (
            paymentData["Card Number"] || paymentData["Account Number"] || paymentData["Value"]
          ).slice(-4),
          accountHolderName: customerInfo.FirstName
            ? customerInfo.FirstName
            : "",
          accCcdExpDte: `${paymentData["Expiration Year"]}${paymentData["Expiration Month"]}01`,
          accCcdSid: 0,
          TransactionID:
            authorizedCardDetails != ""
              ? authorizedCardDetails.TransactionID
              : "",
          AuthorizationCode:
            authorizedCardDetails != ""
              ? authorizedCardDetails.AuthorizationCode
              : "",
          VisaTransID:
            authorizedCardDetails != ""
              ? authorizedCardDetails.VisaTransID
              : "",
          CommercialFlag:
            authorizedCardDetails != ""
              ? authorizedCardDetails.CommercialFlag
              : "",
          CommercialLevel:
            authorizedCardDetails != ""
              ? authorizedCardDetails.CommercialLevel
              : "",
          AuthorizationDate:
            authorizedCardDetails != ""
              ? authorizedCardDetails.AuthorizationDate
              : "",
          otpayment: otPaymentType,
          flag: isNew == true ? "New" : "Exist",
          totalPaymentAmount: payTotalPymtSum,
          authorizedTotal:
            authorizedCardDetails != ""
              ? authorizedCardDetails.PaymentAmount
              : "",
          source: "PayMyBill",
        },
      },
      servicesEnrolled: servicesEnrolled,
    };
  } else if (paymentData.isAccount) {
    let routingNum = paymentData["Routing Number"];
    if (!routingNum || routingNum.length > 9) {
      return Promise.reject({
        genericMessage:
          "Routing Number has too many digits. Maximum of 9 digits. Please try again.",
      });
    }
    if (!routingNum || routingNum.length < 9) {
      return Promise.reject({
        genericMessage:
          "Routing Number has too few digits. Should be 9 digits long. Please try again.",
      });
    }
    requestBody = {
      activeServiceAgreements: salesAgrLst,
      customerNum: cusnum,
      email: customerInfo.EmailAddress ? customerInfo.EmailAddress : "",
      paymentMethod: {
        method: otPaymentType,
        cartDetails: {
          payPymtType: "ACH",
          cardType: "CHK",
          paymentToken: paymentData["Account Number"],
          payCCDExpDte: `${paymentData["Expiration Year"]}-${paymentData["Expiration Month"]}-01`,
          payRoutingNum: paymentData["Routing Number"],
          accountNumber: (
            paymentData["Card Number"] || paymentData["Account Number"] || paymentData["Value"]
          ).slice(-4),
          accountHolderName: customerInfo.FirstName
            ? customerInfo.FirstName
            : "",
          accCcdExpDte: "",
          accCcdSid: 0,
          otpayment: otPaymentType,
          flag: isNew == true ? "New" : "Exist",
          totalPaymentAmount: payTotalPymtSum,
          authorizedTotal: "",
          source: "PayMyBill",
        },
      },
      servicesEnrolled: servicesEnrolled,
    };
  }

  const todaysDate = formatDateDelmtrMMDDYYYY(new Date(), "-");
  const customProperties = {
    payment_last_four: (
      paymentData["Card Number"] || paymentData["Account Number"] || paymentData["Value"]
    ).slice(-4),
    confirmation_number: "",
    services_enrolled: servicesEnrolled.join(),
    enrollment_date: todaysDate,
  };

  const { post: postClient } = BaseClient();

  return postClient(
    process.env.REACT_APP_ECOMM_URL + ecommEndpoints.prePayPaymentV2(),
    requestBody,
    {},
    true,
    mapResponse,
    mapError
  );
};

//map response to object needed by React view
const mapResponse = (response, request) => {
  const responses = response.data;
  if(typeof responses.error === "undefined"){
    var payConfNum = responses?.ConfirmationNumber;
    if (payConfNum) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "Payment success",
        category: "Account",
        action: "payments",
        label: "payment success - prepay",
        customer_id: request?.body?.customerNum,
        error: {
          reason: "",
        },
      });
      return payConfNum;
    } 
  } else {
    return mapError(response);
  }
  //throw new ApiError();
};

//map error to object needed by React view
const mapError = (error) => {
  return error;
};

export {
  PrepayNewPaymentMethodV2,
  PrepayExistingPaymentMethodV2,
  GuestCheckoutNewPaymentMethod,
};
